import React from 'react';
import { ImageFile } from '../../../../../interfaces/salePost';
import CustomFileUploader from '../../../../../components/CustomFileUploader/CustomFileUploader';
import styles from './additionalImages.module.scss';
import {AdditionalImagesProps } from '../../../../../interfaces/pages';

const AdditionalImages = ({
  imagesSelected,
  onChangeFileUploader,
  handleDeleteImage,
  uploaderImages,
  MAX_IMAGES
}: AdditionalImagesProps) => {

  const usedIndices = imagesSelected
    .filter(img => typeof img.index === 'number' && img.index >= 5 && !img.toDelete)
    .map(img => img.index as number);

  const nextFreeIndex = (() => {
    let i = 5;
    while (usedIndices.includes(i) && i < MAX_IMAGES) i++;
    return i;
  })();

  const activeAdditional = imagesSelected.filter(img => typeof img.index === 'number' && img.index >= 5 && !img.toDelete);
  const maxIndex = activeAdditional.length ? Math.max(...activeAdditional.map(img => img.index as number)) : 4;
  const totalActive = imagesSelected.filter(img => !img.toDelete).length;

  if (totalActive === 5) {
    return null; 
  }
  
  const uploaderCount = totalActive >= MAX_IMAGES
    ? maxIndex - 4 
    : maxIndex - 4;
  
  const allUploaderIndices = activeAdditional.length > 0
    ? Array.from({ length: Math.max(uploaderCount, 1) }, (_, i) => i + 5)
    : totalActive > 5 ? [5] : []; 

  return (
    <>
      {allUploaderIndices.map(index => (
        <div className={styles.uploaderItem} key={index}>
          <h3>Foto adicional</h3>
          <CustomFileUploader
            values={imagesSelected?.filter(img => img.index === index) || []}
            onChange={(files: ImageFile[]) => onChangeFileUploader(files, index)}
            onDeleteItem={handleDeleteImage}
            className={styles.fileUploader}
            placeholderImage={uploaderImages.additional}
            loading={imagesSelected?.some(img => img.index === index && img.upload === "loading")}
            deleting={false}
            hideDeleteButton={true}
          />
        </div>
      ))}
    </>
  );
};

export default AdditionalImages;
